import { assembleUrl } from '@/utils/url'
import filedownload from 'js-file-download'

export default class CoursesService {
  constructor($axios, $store) {
    this.axios = $axios
    this.school = $store.state.settings.school
    this.activeCatalog = $store.state.settings.activeCatalog
    this.effectiveDatesRange =
      $store.getters['settings/effectiveDatesRangeAsString']
    this.coursesUrl = `/cm/${this.school}/courses`

    this.coursesFilters = $store.state.settings.coursesFilters
    this.hasFilters =
      this.coursesFilters?.filters && this.coursesFilters?.filters.length > 0

    this.filters = this.hasFilters
      ? {
          ...this.coursesFilters,
          filters: this.coursesFilters.filters,
        }
      : {}
  }

  getCourses({
    query = '$filters',
    skip = 0,
    limit = 50000,
    filters = this.filters,
    department,
    columns = [],
    sortBy,
    courseGroupIds,
    formatDependents = false,
    ignoreEffectiveDating = false,
  }) {
    const skipParam = encodeURIComponent(skip)
    const queryParam = encodeURIComponent(query)
    const limitParam = encodeURIComponent(limit)
    let url = assembleUrl(`${this.coursesUrl}/search/${queryParam}`, {
      catalogId: this.activeCatalog,
      skip: skipParam,
      limit: limitParam,
      orderBy: [ sortBy, ignoreEffectiveDating &&  'effectiveStartDate' ].filter(Boolean).join(','),
      formatDependents,
      effectiveDatesRange: this.effectiveDatesRange,
      ignoreEffectiveDating,
      ...(columns.length ? { columns: columns.join(',') } : {}),
    })

    if (department) url += `&departments=${department}`

    return this.axios.$post(url, {
      ...filters,
      ...(courseGroupIds ? { courseGroupIds } : {}),
    })
  }

  async getCoursesAsCsv({
    query = '$filters',
    filters = this.filters,
    sortBy,
    ignoreEffectiveDating = false,
  }) {
    const url = assembleUrl(`ca/${this.school}/catalogs/${this.activeCatalog}/courses/csv/${query}`, {
      orderBy: [ sortBy, ignoreEffectiveDating &&  'effectiveStartDate' ].filter(Boolean).join(','),
      ignoreEffectiveDating,
    })

    const { data, headers } = await this.axios({
      method: 'post',
      responseType: 'blob',
      url,
      data: filters,
    })
    // Do not download file if response is an error
    if (data === Symbol.for('error') || data instanceof Error) return data
    // Do not download file in tests
    if (process.env.NODE_ENV === 'test') return data

    const contentDisposition = headers['content-disposition'] || ''
    const filenameHeader = contentDisposition.split('filename=')[1] || ''
    const filename = filenameHeader.replace(/"/g, '') || 'courses.csv'

    return filedownload(data, filename)
  }

  getCourse(
    courseGroupId,
    {
      includeRelatedData = true,
      includeCrosslisted = true,
      includeCourseEquivalencies = true,
      columns,
      formatDependents = true,
      includeMappedDocumentItems = false,
      effectiveDatesRange = ''
    } = {}
  ) {
    const url = assembleUrl(`${this.coursesUrl}/search/$filters`, {
      courseGroupIds: courseGroupId,
      effectiveDatesRange: this.effectiveDatesRange,
      formatDependents,
      includeRelatedData,
      includeCrosslisted,
      includeCourseEquivalencies,
      includeMappedDocumentItems,
      includePending: false,
      returnResultsWithTotalCount: false,
      doNotDisplayAllMappedRevisionsAsDependencies: true,
      ...(columns ? { columns } : {}),
      ...(effectiveDatesRange ? { effectiveDatesRange } : {}),
    })

    return this.axios.$get(url).then((data) => {
      return data.data[0]
    })
  }
}
